<template>
  <div class="properties-centent kk-checkbox">
    <div class="properties-body">
      <a-form>
        <a-form-item
          label="问卷中文名称"
        >
          <a-input-search :default-value="''" placeholder="请输入" enter-button @search="executeSearch" />
        </a-form-item>
      </a-form>
      <a-form>
        <a-col :span="24" v-for="(form,index) in formList" :key="index"><a @click="clickFormItem(form)">{{ index + 1 }}. {{ form.name }}</a></a-col>
        <span v-if="formListPages > 1">......</span>
      </a-form>
    </div>
  </div>
</template>
<script>

import { getAction } from '@/api/manage'

export default {
  name: "csimFormRetrieve",
  components: {},
  props: {
    config: {
      type: Object,
      required: true
    },
    previewOptions: {
      type: Object,
      required: true
    },
    selectForm: {
      type: Object,
      required: false
    },
    kDesignType:{
      type:String,
      default:''
    },
    projectId:{
      type:String,
      default:''
    },
  },
  data () {
    return {
      formList: [],
      formListPages: 0
    }
  },
  methods: {
    formChange(vulue, option) {
      // TODO change form design values
    },
    filterOption(input, option) {
      // TODO Get others options
      return {}
    },
    executeSearch(value) {
      console.log(value)
      if (this.kDesignType === 'PROJECT_FORM') {
        getAction('/project/projectForm/listAll', { 
          pageSize: 20, 
          name: "*" + value+ "*",
          column: "createTime",
          order: "desc",
          projectId: this.projectId,
          field: "id,name,nameEn,type_dictText,itemCount,status_dictText,description,action",
          pageNo: 1
        }).then(res => {
          if (res.success) {
            this.formList = res.result
            this.formListPages = res.result.pages
          } else {
            this.$message.error('后台请求异常')
          }
        })
      } else if (this.kDesignType === 'CONFIG_FORM' || this.kDesignType === 'SCHEMA_DESIGN') {
        getAction('/tempconfig/tempConfigForm/list', { pageSize: 20, name: "*" + value+ "*" }).then(res => {
          if (res.success) {
            this.formList = res.result.records
            this.formListPages = res.result.pages
          } else {
            this.$message.error('后台请求异常')
          }
        })
      }
    },
    clickFormItem(form) {
      console.log(form);

      this.$emit("handleSetSelectForm", form);
    },
    reset() {
      this.formList = [];
      this.formListPages = 0;
    }
  }
};
</script>
